<template>
  <div class="company-profile">
    <Header></Header>
    <div class="company-info">
      <b-container>
        <b-row>
          <b-col md="4" cols="12">
            <div class="company-brief">
              <div class="company-logo">
                <img
                  v-if="companyData.image"
                  :src="companyData.image.url"
                  alt=""
                />
              </div>
              <div class="company-name">{{ companyData.name }}</div>
              <hr v-if="isAuthenticated" />
              <b-row v-if="isAuthenticated">
                <b-col class="info-label">عدد المدربين</b-col>
                <b-col class="info-value"
                  >{{ employeesList.count }}</b-col
                >
              </b-row>
            </div>
            <b-row v-if="isAuthenticated">
              <div class="tab-container">
                <!-- <b-col md="12" cols="12">
                  <div class="row">
                    <div class="sec-wrapper d-flex align-items-center mb-4">
                      <h3 id="famous-companies " class="side-title">
                        الشهادات و الرخص
                      </h3>
                    </div>
                    <div
                      v-for="certificate in companyData.certificates"
                      :key="certificate.id"
                      class="col-md-6 col-12 mb-30"
                    >
                      <router-link :to="`/cerificate/${certificate.id}`">
                        <ImageView
                          v-if="certificate.file"
                          :imageFile="certificate.file.url"
                        />
                      </router-link>
                    </div>
                  </div>
                </b-col> -->
                <b-col md="12" cols="12" v-if="companyData.training_programs">
                  <div class="row" v-if="companyData.training_programs.length > 0">
                    <div class="sec-wrapper d-flex align-items-center mb-4">
                      <h3 id="famous-companies " class="side-title">
                        التدريبات
                      </h3>
                    </div>
                    <div
                      v-for="program in companyData.training_programs"
                      :key="program.id"
                      class="col-md-6 col-12 mb-30"
                    >  
                  <ImageView
                    :imageFile="program.image.url"
                  />
                  <div class="d-flex  align-items-star">
                  <p >{{ program.title }}</p>
                </div>
                
                    </div>
                  </div>
                </b-col>
              </div>
            </b-row>
          </b-col>
          <b-col md="8" cols="12">
            <div class="tab-container">
              <CompanyContact :companyData="companyData"></CompanyContact>
            </div>
            <div class="tab-container" v-if="isAuthenticated">
              <EmployeesList
                :employeesList="employeesList"
                :columns="columns"
                type="trainers"
              ></EmployeesList>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="!isAuthenticated">
          <!-- <b-col md="12" cols="12"  v-if="companyData.certificates">
            <div class="row" v-if="companyData.certificates.length > 0">
              <div class="sec-wrapper d-flex align-items-center mb-4" >
                <h2 id="famous-companies " class="section-title">الشهادات</h2>
                <div class="blue-line"></div>
              </div>
              <b-row >
                <div
                  v-for="certificate in companyData.certificates"
                  :key="certificate.id"
                  class="col-md-3 col-12 mb-30"
                >
                  <ImageView
                    v-if="certificate.file"
                    :imageFile="certificate.file.url"
                  />
                </div>
              </b-row>

            </div>
          </b-col> -->
          <b-col md="12" cols="12" >
            <div class="row" >
              <div class="sec-wrapper d-flex align-items-center mb-4">
                <h2 id="famous-companies " class="section-title">التدريبات</h2>
                <div class="blue-line"></div>
              </div>
              <b-row >
                <div
                  v-for="program in companyData.training_programs"
                  :key="program.id"
                  class="col-md-3 col-12 mb-30"
                >
                <router-link  :to="`/training-program/${program.id}`">
                  <ImageView
                    :imageFile="program.image.url"
                  />
                  <div class="d-flex justify-content-center align-items-center py-3">
                  <p >{{ program.title }}</p>
                </div>
              </router-link>

                </div>
              </b-row>

            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import CompanyContact from "@/components/Company/CompanyContact.vue";
import EmployeesList from "@/components/Company/EmployeesList.vue";
import Header from "@/components/Company/Header.vue";
import Footer from "@/components/Home/Footer.vue";
import ImageView from "@/components/common/ImageView.vue";
import axios from "axios";

export default {
  name: "CompanyShow",
  components: { Header, Footer, EmployeesList, CompanyContact, ImageView },
  data() {
    return {
      tabIndex: 0,
      companyData: {},
      employeesList: [],
      columns: [
        { field: "name", title: "اسم المدرب" },
        { field: "position", title: "محتوي التدريب " },
        { field: "gender", title: " الجنس" },
        { field: "nationality", title: " الجنسية" },
        { field: "actions", title: "عرض" },
      ],

      companyLocation: {},
      searchQuery: null,
    };
  },
  async created() {
    // Fetch data from APIs
    await this.fetchCompanyData();
    await this.fetchEmployeesList();
    this.$store.dispatch("companies/fetchCompanysTrainingsPublicData");
  },
  watch: {
    searchQuery: {
      immediate: true,
    },
  },
  computed: {
    companysTrainingsData() {
      return this.$store.state.companies.companysTrainingsPublicData;
    },
    isAuthenticated() {
      // Check if the token exists in localStorage
      return !!localStorage.getItem("token");
    },
  },
  methods: {
    async fetchCompanyData() {
      try {
        if (this.isAuthenticated) {
          const response = await axios.get(
            `ministries/training_companies/${this.$route.params.id}`
          );
          this.companyData = response.data.data.training_company;
        } else {
          const response = await axios.get(
            `show_training_company/${this.$route.params.id}`
          );
          this.companyData = response.data.data.training_company;
        }
      } catch (error) {
        console.error("Error fetching company data:", error);
      }
    },
    async fetchEmployeesList(page) {
      try {
        const response = await axios.get(
          `ministries/training_companies/${this.$route.params.id}/trainers?`,
          {
            params: { value: this.searchQuery, field: "name", page: page },
          }
        );
        this.employeesList = response.data.data;

      } catch (error) {
        console.error("Error fetching employees list:", error);
      }
    },
    handlePageChange(page) {
      this.fetchEmployeesList(page);
    },
    async updateSearch(query) {
      // Update the search query and make the API call
      this.searchQuery = query;
    },
  },
};
</script>
<style lang="">
</style>
